import { RouteName } from '@mews-commander/enums';
import { linkFactory } from '@mews/routing';
import { Link, LinkProps } from '@optimus-web/core';

const CommanderLink = linkFactory({ LinkElement: Link });

export interface RouteLinkProps extends LinkProps {
    route: RouteName;
    params?: {};
    action?: 'push' | 'replace' | 'back' | 'forward';
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

/** @deprecated use EnterpriseLink */
export const RouteLink = ({ action = 'push', onClick = () => {}, params = {}, ...other }: RouteLinkProps) => (
    <CommanderLink action={action} onClick={onClick} params={params} {...other} />
);
